import { CSSProperties } from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import FulfillingMoment from 'components/display/FulfillingMoment'
import type { FulfillingMomentName } from 'components/display/FulfillingMoment/types'

const groupByThree = <T extends unknown>([a, b, c, ...rest]: T[]): Array<
  T[]
> => {
  if (rest.length === 0) {
    return [[a, b, c].filter((item) => item !== undefined)]
  }

  return [[a, b, c]].concat(groupByThree(rest))
}

const mobileGutter = 16
const desktopGutter = 32

const Outer = styled.div`
  width: 100%;
  overflow-x: scroll;
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${mobileGutter}px;
  width: fit-content;

  ${media.md`
    margin: 0 auto;
  `}
`

const Row = styled.div`
  flex-shrink: 0;
  width: fit-content;
  display: flex;
  margin-bottom: ${mobileGutter}px;

  & > *:not(:last-child) {
    flex-shrink: 0;
    margin-right: ${mobileGutter}px;
  }

  ${media.md`
    margin-bottom: ${desktopGutter}px;

    &:nth-child(4n+2) {
      margin-left: ${desktopGutter * 2}px;
    }

    &:nth-child(4n+3) {
      margin-left: ${desktopGutter * 1}px;
    }

    &:nth-child(4n+4) {
      margin-left: ${desktopGutter * 3}px;
    }

    & > *:not(:last-child) {
      margin-right: ${desktopGutter}px;
    }
  `}
`

const moments: FulfillingMomentName[] = [
  'peacefulness',
  'rejuvenation',
  'groundedness',
  'slowness',
  'human connection',
  'joy',
  'unplugged',
  'freedom',
  'self-discovery',
  'excitement',
  'spontaneity',
  'challenge',
]

const FulfillingMomentsGrid = ({ style }: { style?: CSSProperties }) => {
  const momentRows = groupByThree(moments)

  return (
    <Outer style={style}>
      <Inner>
        {momentRows.map((row) => {
          return (
            <Row key={row[0]}>
              {row.map((momentName) => {
                return (
                  <FulfillingMoment key={momentName} momentName={momentName} />
                )
              })}
            </Row>
          )
        })}
      </Inner>
    </Outer>
  )
}

export default FulfillingMomentsGrid
